module.exports = __webpack_public_path__ + "img/CM-MS-CA-23-Toyota-Lifestyle.978a925f.jpeg";